/**
 * IT Admin → People & access → "View as…" (6 Oct): pick a person, see the
 * HelpDesk as they do, read-only. Admins on VIEW_AS_EMAILS only (LIVE: Rusty); the server
 * refuses everyone else, and production entirely.
 */

import { Alert, Field, Typography } from "@norican/react";
import { useState } from "react";

import { PageContainer, SectionCard } from "@/components/common";
import { EmployeePicker } from "@/features/tickets";
import { useDocumentTitle } from "@/hooks";
import { useT } from "@/i18n";
import { useMe } from "@/lib/api";

import { ViewAsButton } from "./view-as-button";
import { mayOfferViewAs } from "./view-as-state";

export function ViewAsPage() {
  const { t } = useT();
  const { t: tt } = useT("errors");
  useDocumentTitle(t("viewAs.page.title"));
  const { data: me } = useMe();
  const [employeeId, setEmployeeId] = useState<string | null>(null);
  const [name, setName] = useState<string | null>(null);

  return (
    <PageContainer title={t("viewAs.page.title")}>
      {mayOfferViewAs(me) ? (
        <SectionCard title={t("viewAs.page.title")}>
          <div className="flex flex-col gap-3">
            <Typography variant="body-sm" tone="muted">
              {t("viewAs.page.intro")}
            </Typography>
            <Field name="view-as-person" label={t("viewAs.page.person")}>
              <EmployeePicker
                name="view-as-person"
                value={employeeId}
                defaultDisplayValue={name}
                onChange={(entry) => {
                  setEmployeeId(entry?.id ?? null);
                  setName(entry?.display_name ?? null);
                }}
                aria-label={t("viewAs.page.person")}
              />
            </Field>
            <ViewAsButton employeeId={employeeId ?? ""} />
            <Typography variant="caption" tone="muted">
              {t("viewAs.page.logged")}
            </Typography>
          </div>
        </SectionCard>
      ) : (
        <Alert tone="neutral">{tt("code.ADMIN_REQUIRED")}</Alert>
      )}
    </PageContainer>
  );
}
